import { clearAuth, storeRedirectPath, getStoredRedirectPath } from '../services/wellnessAuth';

/**
 * Handle automatic redirect when wellness authentication fails
 * This function can be called from API error handlers when tokens are expired or invalid
 */
export const handleWellnessAuthFailure = (reason: string = 'Authentication failed') => {
  console.warn(`[WellnessAuthRedirect] ${reason}, redirecting to login`);
  
  try {
    // Clear wellness auth state (tokens, user, etc.)
    clearAuth();
    
    // Store the current location for redirect after login, but only for wellness paths
    // (non-wellness paths like "/" shouldn't override the default post-login destination)
    const currentPath = window.location.pathname + window.location.search;
    if (
      currentPath.startsWith('/wellness') &&
      !currentPath.startsWith('/wellness/login') &&
      !currentPath.startsWith('/wellness/verify') &&
      !currentPath.startsWith('/wellness/signup')
    ) {
      storeRedirectPath(currentPath);
    }
    
    // Redirect to wellness login page
    window.location.href = '/wellness/login';
  } catch (error) {
    console.error('[WellnessAuthRedirect] Error during auth failure handling:', error);
    // Force redirect even if logout fails
    window.location.href = '/wellness/login';
  }
};

/**
 * Get the stored redirect path after successful wellness login
 * Note: This function does NOT clear the redirectPath - it should be cleared after use
 * @deprecated Use getStoredRedirectPath from wellnessAuth service directly
 */
export const getWellnessRedirectPath = (): string | null => {
  return getStoredRedirectPath();
};



